import React from 'react';
import Materia from './materia';
import Anio from './anio';

function Carrera({data}) {

    const {carrera, materias, id} = data;

    if(!materias) return null;

    
    const getMatsByAnioCuatri = (anio, cuatri) => materias.filter( m => m.cuatri === cuatri && m.anio === anio);

    const materiasContinuas = getMatsByAnioCuatri(0, 0);

    const a1 = getMatsByAnioCuatri(1, 0);
    const a2 = getMatsByAnioCuatri(2, 0);
    const a3 = getMatsByAnioCuatri(3, 0);
    const a4 = getMatsByAnioCuatri(4, 0);

    const a1_s1 = getMatsByAnioCuatri(1, 1);
    const a1_s2 = getMatsByAnioCuatri(1, 2);
    const a2_s1 = getMatsByAnioCuatri(2, 1);
    const a2_s2 = getMatsByAnioCuatri(2, 2);
    const a3_s1 = getMatsByAnioCuatri(3, 1);
    const a3_s2 = getMatsByAnioCuatri(3, 2);
    const a4_s1 = getMatsByAnioCuatri(4, 1);
    const a4_s2 = getMatsByAnioCuatri(4, 2);
    
    return (
        <React.Fragment>
            <h1>{carrera}</h1>

            { materias.length < 1 && 
                <h2>No hay materias asignadas</h2>
            }

            { (a1.length + a2.length + a3.length + a4.length) > 0 ?
                <>

                    <Anio todo={a4} anio="4" />

                    <Anio todo={a3} anio="3" />

                    <Anio todo={a2} anio="2" />

                    <Anio todo={a1} anio="1" />

                </>
                : null
            }

            { materiasContinuas.length > 0 ?

                <ul className="anios">
                    <li className="desplegado">
                        <ul className="materia">
                            { materiasContinuas.map( materia => {           
                                    return (
                                        <Materia key={materia.id} data={materia} />
                                    );
                                })
                            }            
                        </ul>
                    </li>
                </ul>

            : null

            }

            { id === 64 || carrera === 'CURSILLO CIES' || id===-20 ? 
                <ul className="anios">
                    <li className="desplegado">
                        <ul className="materia">
                            { materias.map( materia => {           
                                    return (
                                        <Materia key={materia.id} data={materia} />
                                    );
                                })
                            }            
                        </ul>
                    </li>
                </ul>
            :
                <>

                    <Anio semestre1={a4_s1} semestre2={a4_s2} anio="4" />

                    <Anio semestre1={a3_s1} semestre2={a3_s2} anio="3" />

                    <Anio semestre1={a2_s1} semestre2={a2_s2} anio="2" />

                    <Anio semestre1={a1_s1} semestre2={a1_s2} anio="1" />

                </>
            }

        </React.Fragment>
    );
}

export default React.memo(Carrera);